import { technicianDefault } from "../domain/technician/technician";
import { headers } from '../const/headers'
import { snackbar } from "@/core/controller/snackbar_controller";

class TechnicianController {
  context = null;
  headers = headers;
  loading = false;
  search = "";
  searchCity = "";
  dialog = false;
  form = technicianDefault();
  statusSelected = 0;
  statusList = [
    {text: "Todos", value: 0},
    {text: "Ativo", value: 1},
    {text: "Inativo", value: 2}
  ];
  addressRules = value => {
    const pattern = /^[a-zA-Z0-9\s,.-]+$/
    if(!value) return 'Campo obrigatório'
    if(value.length < 5) return 'Endereço muito curto'
    return pattern.test(value) || 'Endereço inválido'
  }

  technicianPagination = {
    total: 0,
    items: []
  }
  options = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["id"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  cityPagination = {
    total: 0,
    items: []
  }
  cityOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  constructor (
    context,
    fetchTechnicianUsecaseImpl,
    fetchCityUseCaseImpl,
    createTechnicianUsecaseImpl,
    changeTechnicianUsecaseImpl,
    deleteTechnicianUsecaseImpl
  ) {
    this.context = context
    this.fetchTechnicianUsecaseImpl = fetchTechnicianUsecaseImpl
    this.fetchCityUseCaseImpl = fetchCityUseCaseImpl
    this.createTechnicianUsecaseImpl = createTechnicianUsecaseImpl
    this.changeTechnicianUsecaseImpl = changeTechnicianUsecaseImpl
    this.deleteTechnicianUsecaseImpl = deleteTechnicianUsecaseImpl
  }

  async paginate () {
    this.loading = true
    try {
        this.technicianPagination = await this.fetchTechnicianUsecaseImpl(this.options, this.search, this.statusSelected)
    } catch (error) {
        console.log(error);
    } finally {
        this.loading = false
    }
  }

  async cityPaginate() {
    try {
      this.cityPagination = await this.fetchCityUseCaseImpl(this.cityOptions, this.searchCity)
    } catch (error) {
      console.log(error);
    }
  }

  open() {
    this.form = technicianDefault()
  }

  close() {
    this.context.$refs.crud.resetValidation()
    this.dialog = false
  }

  async create() {
    if(this.context.$refs.crud.validate()){
      try {
        this.loading = true
        if(this.form.id != 0){
          await this.changeTechnicianUsecaseImpl(this.form.id, this.form)
          snackbar.show({ message: "Alterado com sucesso!", color: "#008000", timeout: 3000 })
        } else {
          await this.createTechnicianUsecaseImpl(this.form)
          snackbar.show({ message: "Adicionado com sucesso!", color: "#008000", timeout: 3000 })
        }
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 5000 })
      } finally {
        this.paginate()
        this.loading = false
        this.dialog = false
      }
    }
  }

  change(item) {
    this.dialog = true
    this.form = { ...item }
    this.searchCity = item.cityName
    this.cityPaginate()
  }

  async delete(item) {
    try {
      const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
      if(confirm){
        await this.deleteTechnicianUsecaseImpl(item.id)
        this.paginate()
        snackbar.show({ message: "Registro excluído com sucesso!", color: "#008000", timeout: 3000 })
      }
    } catch (error) {
      snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 4000 })
    }
  }

  async checkboxChange(item) {
    if(!item || item.id === undefined || item.active === undefined) {
      console.error('Item inválido', item);
      return
    }
    try {
      this.form = { ...item }
      this.form.active = item.active

      const res = await this.changeTechnicianUsecaseImpl(this.form.id, this.form)
      if(res) {
        snackbar.show({ message: "Status alterado com sucesso!", color: "#008000", timeout: 3000 })
        this.paginate()
      }
    } catch (error) {
      snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 4000 })
    }
  }

  watchOptions() {
    this.paginate()
  }
  watchSearch() {
    this.paginate()
  }
  watchCityOptions() {
    this.cityPaginate()
  }
  watchCitySearch() {
    this.cityPaginate()
  }
}

export default TechnicianController